import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import MobileHeader from './MobileHeader';
import BottomNav    from './BottomNav';

export default function AppShell({ theme, onToggleTheme }) {
  const location = useLocation();
  const [navVisible, setNavVisible] = useState(true);
  const [lastY, setLastY] = useState(0);

  // Auto-hide bottom nav on scroll-down, show on scroll-up
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      if (Math.abs(y - lastY) < 8) return;
      setNavVisible(y < lastY || y < 80);
      setLastY(y);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastY]);

  return (
    <div
      className={`min-h-screen w-full relative overflow-x-hidden
        ${theme === 'dark' ? 'bg-ink text-slate-100' : 'bg-[#f6f7fb] text-slate-900'}`}
    >
      {/* Animated mesh background */}
      <div
        aria-hidden
        className={`fixed inset-0 -z-10 ${
          theme === 'dark' ? 'bg-mesh-dark' : 'bg-mesh-light'
        }`}
      />
      <div
        aria-hidden
        className="fixed inset-0 -z-10 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)',
          backgroundSize: '24px 24px'
        }}
      />

      <MobileHeader theme={theme} onToggleTheme={onToggleTheme} />

      <main className="max-w-7xl mx-auto px-3 sm:px-5 lg:px-8 pt-3 sm:pt-5 pb-safe">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.22, ease: 'easeOut' }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      <BottomNav visible={navVisible} />
    </div>
  );
}
